import React from 'react';

export const SheetLink = ({ to, title, children, testid, newTab = true }) => (to
  ? <a href={to} {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})} title={title} data-testid={testid} className="sheet-link"
      style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}>{children}</a>
  : children);

export const SHEET_LINK_CSS = `.sheet-link:hover { text-decoration: underline !important; text-decoration-color: #FACC15 !important; text-underline-offset: 3px; }
@media print { .sheet-link { text-decoration: none !important; } }`;
